<div class="w-100 mt-0 tool-container">
  <h4>Patch Profile</h4>
  <mat-form-field class="me-3">
    <mat-label>Application</mat-label>
    <mat-select [(ngModel)]="patchProfile.app">
      @for (app of applications; track app.value) {
        <mat-option [value]="app.value">
          {{ app.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="me-2">
    <mat-label>Profile ID</mat-label>
    <input matInput [(ngModel)]="patchProfile.id" />
  </mat-form-field>
  <span class="radio-container ps-2 me-3">
    <mat-label>Evaluate Functions Only</mat-label>
    <mat-radio-group [(ngModel)]="patchProfile.evaluate">
      <mat-radio-button [value]="true" class="me-3">Yes</mat-radio-button>
      <mat-radio-button [value]="false">No</mat-radio-button>
    </mat-radio-group>
  </span>
  <span class="radio-container ps-2 me-3">
    <mat-label>Return Profile</mat-label>
    <mat-radio-group [(ngModel)]="patchProfile.returnProfile">
      <mat-radio-button [value]="true" class="me-3">Yes</mat-radio-button>
      <mat-radio-button [value]="false">No</mat-radio-button>
    </mat-radio-group>
  </span>
  <mat-form-field class="profile-json-container me-3">
    <mat-label>Profile JSON</mat-label>
    <textarea
      matInput
      [(ngModel)]="patchProfile.data"
      matTextareaAutosize
      matAutosizeMinRows="3"
    ></textarea>
  </mat-form-field>
  <button
    mat-raised-button
    color="primary"
    class="mx-auto"
    (click)="saveProfilePatch()"
    [disabled]="!patchProfile.id || !patchProfile.data || !patchProfile.app"
  >
    Patch
  </button>
</div>
